import React from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import FlowDiagram from "./components/FlowDiagram";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
    background: {
      default: "#fafafa",
    },
  },
});

interface RetrospectivesProps {
  onBack: any;
  sprintId: string;
  sprintName: string;
  reactFlow: any;
  parentData?: any;
}

const Retrospectives: React.FC<RetrospectivesProps> = ({
  sprintId,
  sprintName,
  reactFlow,
  parentData,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <FlowDiagram
        sprintId={sprintId}
        sprintName={sprintName}
        reactFlow={reactFlow}
        parentData={parentData}
      />
    </ThemeProvider>
  );
};

export default Retrospectives;
